import React from "react";
import { Button } from "@a365/dsys";
import { useIsMobile, useBreakpointDown } from "@a365/core";

const BannerCard4 = ({ bannerData, setOpenMod }) => {
  const isMobile = useIsMobile();
  const isMD = useBreakpointDown("md");

  return (
    <div
      className="
      overflow-hidden
      relative z-10 text-wrap 
      w-full
      h-auto
      xl:w-[486px] xl:min-w-[486px] xl:h-[280px]
      flex items-start justify-center flex-col
      rounded-2xl bg-brand-comp-green p-4 xl:p-6 
      xl:space-y-1
    "
    >
      <span className="text-text-default text-base xl:text-xl font-semibold leading-6">
        {bannerData?.slide_2?.right?.subtext}
      </span>
      <span className="inline-block text-text-default text-xl xl:text-3xl font-semibold leading-7 xl:leading-10">
        {bannerData?.slide_2?.right?.title}
      </span>
      <p className="text-base xl:text-2xl text-text-default leading-6 xl:leading-8">
        {bannerData?.slide_2?.right?.dropline}
      </p>

      <Button
        onClick={() => setOpenMod(true)}
        color="primary"
        fullWidth={isMobile ?? false}
        size={isMobile && isMD ? "small" : "large"}
        icon="arrow"
        classes="pt-4 xl:pt-6 w-full relative z-10"
      >
        {bannerData?.slide_2?.right?.cta}
      </Button>

      <div
        className="
      bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/banner/shape1.svg')]
      absolute w-[143px] h-[280px] right-0 top-0 z-5 bg-cover"
      ></div>
    </div>
  );
};

export default BannerCard4;
